"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.find-index");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _two = _interopRequireDefault(require("@/components/upload/two"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _index = require("@/utils/index");
var _auth = require("@/utils/auth");
var _editwith = _interopRequireDefault(require("./_editwith"));
var _reportContent = require("@/utils/reportContent");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 【操作埋点】2026-05-25
 * 说明：content 格式化；下列 $post 第三参数经 request 拦截器成功后自动上报
 */
var _default = exports.default = {
  name: 'agent',
  components: {
    upload: _two.default,
    Pagination: _Pagination.default,
    drawer: _filter.default,
    selPlat: _selPlat.default,
    editwith: _editwith.default
  },
  props: {
    user_type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    var _this = this;
    return {
      sort_type: [{
        name: '综合排序',
        value: 0
      }, {
        name: '收益从高到低',
        value: 1
      }, {
        name: '收益从低到高',
        value: 2
      }, {
        name: '创建时间由近到远',
        value: 3
      }, {
        name: '创建时间由远到近',
        value: 4
      }],
      form: {},
      give_role: [],
      tableMaxH: '250',
      list: [],
      put_place: [],
      is_clear_wx_user: 0,
      listLoading: true,
      frozenAvailableTotal: 0,
      listQuery: {
        activated_status: 1,
        search_agent_id: '0',
        sort_type: '0',
        search_agent_level: '0',
        put_place: '',
        son_type: 0,
        is_frozen: '-1',
        start: 1,
        limit: 10,
        page_num: 1
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      zuo_sn: '',
      selSnArr: [],
      // 提现费率
      withdrawObj: {},
      withdrawDialog: false,
      isSyqkDialog: false,
      isSyqkObj: {},
      // 提现手续费
      withdrawFeeObj: {},
      withdrawFeeDialog: false,
      // 提现手续费
      isFrozenObj: {},
      isFrozenDialog: false,
      //余额增值
      isYezzObj: {},
      isYezzDialog: false,
      // terminal角色 代理账号设置
      terminalAccountSettingVisible: false,
      terminalAccountLoading: false,
      terminalAccountSaving: false,
      terminalAccountObj: {
        aid: 0,
        is_disable_account: 0,
        is_disable_equipment: 0,
        is_frozen: 0
      },
      //添加推荐官
      addPromoterAgentObj: {},
      addPromoterAgentDialog: false,
      //平台补贴比例设置
      balanceSetObj: {},
      banlanceSetDialog: false,
      // 商户电费授权
      merchantElectricityAuthDialog: false,
      merchantElectricityAuthLoading: false,
      merchantElectricityAuthSaving: false,
      merchantElectricityAuthSkipSave: false,
      merchantElectricityAuthObj: {
        aid: 0,
        name: '',
        has_access: 0
      },
      // 免费店员
      freeObj: {},
      freeDialog: false,
      iconDialog: false,
      brand_icon: {},
      breakEvenDialog: false,
      currentShopInfo: {},
      calculateCostLoading: false,
      deviceTypeOptions: [{
        value: '0',
        label: '全部'
      }, {
        value: '1',
        label: '充电宝'
      }, {
        value: '5',
        label: '充电桩'
      }, {
        value: '3',
        label: '充电线'
      }, {
        value: '9',
        label: '套套机'
      }],
      selectedDeviceType: '0',
      costForm: {
        deviceCost: '0',
        installationCost: '0',
        laborCost: '0',
        otherCost: '0',
        totalCost: '0',
        remark: '',
        cdbCost: '0',
        cdxCost: '0',
        cdz10Cost: '0',
        cdz2Cost: '0',
        cdz2lyCost: '0',
        cdz2hpCost: '0',
        zmcdbCost: '0',
        lykgczCost: '0',
        cdbInstallCost: '0',
        cdxInstallCost: '0',
        cdz10InstallCost: '0',
        cdz2InstallCost: '0',
        cdz2lybInstallCost: '0',
        cdz2hpInstallCost: '0',
        zmcdbInstallCost: '0',
        lykgczInstallCost: '0',
        cdbLaborCost: '0',
        cdxLaborCost: '0',
        cdz2LaborCost: '0',
        cdz10LaborCost: '0',
        cdz2lybLaborCost: '0',
        cdz2hpLaborCost: '0',
        zmcdbLaborCost: '0',
        lykgczLaborCost: '0',
        cdbOtherCost: '0',
        cdxOtherCost: '0',
        cdz2OtherCost: '0',
        cdz10OtherCost: '0',
        cdz2lybOtherCost: '0',
        cdz2hpOtherCost: '0',
        zmcdbOtherCost: '0',
        lykgczOtherCost: '0'
      },
      investmentRatio: {
        partner: '0',
        manage: '0',
        proxy: '0',
        salesperson: '0',
        promoter: '0',
        merchants: '0'
      },
      recoveryRatio: {
        manage: '',
        partner: '',
        proxy: '',
        salesperson: '',
        promoter: '',
        merchants: ''
      },
      breakEvenDays: 0,
      breakEvenPercentage: 0,
      averageDailyIncome: 0,
      recoveredCost: 0,
      remainingCost: 0,
      daysSinceOperation: 0,
      averageChangeMoneyMonth: 0
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == "agentEdit") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated: function activated() {
    this.zuo_sn = this.$route.query.zuo_sn || '';
    if (!this.$route.meta.isBack || !this.list) {
      this.getPower();
      this.listQuery.son_type = this.user_type;
      this.toQuery(1);
    }
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {},
  methods: {
    getToken: _auth.getToken,
    /**
     * 获取权限
     */
    getPower: function getPower() {
      var _this2 = this;
      var give_role = [{
        role_name: '全部',
        role_id: 0
      }];
      this.$get('agentapi/add_agent').then(function (res) {
        _this2.give_role = give_role.concat(res.give_role_right);
        _this2.put_place = res.put_place;
      });
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery = {
          activated_status: 1,
          search_agent_id: '0',
          sort_type: '0',
          search_agent_level: '0',
          put_place: '',
          son_type: 0,
          start: 1,
          limit: 10,
          page_num: 1
        };
      }
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;
      this.listQuery.son_type = this.user_type;
      var url = 'agentapi/son_list';
      var listQuery = Object.assign(this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      this.$get(url, listQuery).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.list;
        _this3.listQuery.page_num = res.page_num;
        //已冻结筛选时，记录可提金额总和
        _this3.frozenAvailableTotal = Number(res.frozen_available_total || 0);
        if (listQuery.start == 0) _this3.tableMaxH = window.innerHeight - _this3.$refs.list_table.$el.offsetTop - 80;
        if (_this3.getToken('agent_id') == 173) {
          _this3.getBreakEvenCycleDataToList();
        }
      }).catch(function () {
        _this3.listLoading = false;
        _this3.frozenAvailableTotal = 0;
      });
    },
    /**
     * 编辑
     */
    set: function set(row) {},
    /**
     * 编辑
     * @param {Object} row
     */
    toEdit: function toEdit(row, rows) {
      var _this4 = this;
      // 【操作埋点】2026-05-25 本方法内各 case 的 $post 第三参数含 operation_id，成功后自动上报
      switch (row.type) {
        case 1:
          this.$router.push({
            name: 'agentEdit',
            params: {
              id: row.id
            }
          });
          break;
        case 2:
          this.$prompt('请输入冻结金额', '设置冻结金额', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: row.freez_money
          }).then(function (_ref) {
            var value = _ref.value;
            // 【操作埋点】2026-05-25 pc_agent_freez_money_1 设置冻结金额
            _this4.$post('agentapi/save_agent_freez_money', {
              son_id: row.id,
              freez_money: value
            }, {
              operation_option: '设置冻结金额',
              content: "\u4EE3\u7406\u5546".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, ''), "\uFF0C\u51BB\u7ED3\u91D1\u989D\uFF1A").concat(value, " \u5143\uFF08\u539F\uFF1A").concat(row.freez_money || 0, " \u5143\uFF09"),
              operation_id: 'pc_agent_freez_money_1'
            }).then(function (res) {
              _this4.$message({
                message: '设置成功',
                type: 'success'
              });
              row.freez_money = value;
            });
          });
          break;
        case 3:
          this.$get('agentapi/edit_agent', {
            son_id: row.id
          }).then(function (res) {
            _this4.withdrawDialog = true;
            _this4.withdrawObj = res.agent_info;
          });
          break;
        case 4:
          this.$alert('确定删除此代理吗？', '删除代理', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              if (action == 'confirm') {
                // 【操作埋点】2026-05-25 pc_agent_delete_1 删除代理
                _this4.$post('agentapi/delete_agent', {
                  son_id: row.id
                }, {
                  operation_option: '删除代理',
                  content: "\u5220\u9664\u4EE3\u7406".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, '')),
                  operation_id: 'pc_agent_delete_1'
                }).then(function (res) {
                  _this4.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  _this4.list.splice(row.index, 1);
                });
              }
            }
          });
          break;
        case 5:
          this.$prompt('请输入新登录密码', '重置登录密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                // 【操作埋点】2026-05-25 pc_agent_password_1 重置登录密码
                _this4.$post('agentapi/edit_agent_password', {
                  son_id: row.id,
                  password: value
                }, {
                  operation_option: '重置登录密码',
                  content: "\u91CD\u7F6E\u4EE3\u7406".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, ''), " \u7684\u767B\u5F55\u5BC6\u7801"),
                  operation_id: 'pc_agent_password_1'
                }).then(function (res) {
                  _this4.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
        case 6:
          // 【操作埋点】2026-05-25 pc_agent_member_1 设置免费店员
          this.$post('agentapi/sttuf/save_member_setting', {
            son_id: rows.id,
            member_num: rows.member_num,
            member_day_count: rows.member_day_count,
            member_free_due_hours: rows.member_free_due_hours
          }, {
            operation_option: '设置免费店员',
            content: (0, _reportContent.buildReportContent)({
              member_num: rows.member_num,
              member_day_count: rows.member_day_count,
              member_free_due_hours: rows.member_free_due_hours
            }, {
              member_num: '店员数量',
              member_day_count: '免费天数',
              member_free_due_hours: '免费时长(小时)'
            }, {
              prefix: (0, _reportContent.buildSubjectPrefix)(rows.name, rows.id, '代理商')
            }),
            operation_id: 'pc_agent_member_1'
          }).then(function (res) {
            _this4.$message({
              message: '设置成功',
              type: 'success'
            });
            _this4.freeDialog = false;
          });
          break;
        case 7:
          this.$prompt('请输入新提现密码', '重置提现密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                // 【操作埋点】2026-05-25 pc_agent_password_1 重置提现密码
                _this4.$post('agentapi/edit_agent_password', {
                  son_id: row.id,
                  password: value,
                  type: 1
                }, {
                  operation_option: '重置提现密码',
                  content: "\u91CD\u7F6E\u4EE3\u7406".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, ''), " \u7684\u63D0\u73B0\u5BC6\u7801"),
                  operation_id: 'pc_agent_password_1'
                }).then(function (res) {
                  _this4.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
        case 8:
          this.$alert('确定恢复此代理吗？', '恢复代理', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              if (action == 'confirm') {
                // 【操作埋点】2026-05-25 pc_agent_active_1 恢复代理
                _this4.$post('agentapi/sttuf/update_active_status', {
                  son_id: row.id,
                  active_status: 1
                }, {
                  operation_option: '恢复代理',
                  content: "\u6062\u590D\u4EE3\u7406".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, '')),
                  operation_id: 'pc_agent_active_1'
                }).then(function (res) {
                  _this4.$message({
                    message: '恢复成功',
                    type: 'success'
                  });
                  _this4.list.splice(row.index, 1);
                });
              }
            }
          });
          break;
        case 9:
          this.$get('agentapi/getAdminWithdrawConfig', {
            admin_id: row.id
          }).then(function (res) {
            _this4.withdrawFeeDialog = true;
            _this4.withdrawFeeObj = res;
            _this4.withdrawFeeObj.admin_id = row.id;
          });
          break;
        case 10:
          this.$get('agentapi/admin/getDeposit', {
            agents_id: row.id
          }).then(function (res) {
            _this4.banlanceSetDialog = true;
            _this4.balanceSetObj = res;
          });
          break;
        case 11:
          this.$get('agentapi/admin/getFrozen', {
            admin_id: row.id
          }).then(function (res) {
            _this4.isFrozenDialog = true;
            _this4.isFrozenObj = res;
          });
          break;
        case 12:
          this.$get('agentapi/admin/getYezz', {
            admin_id: row.id
          }).then(function (res) {
            _this4.isYezzDialog = true;
            _this4.isYezzObj = res;
          });
          break;
        case 13:
          this.load = this.$message({
            duration: 0,
            iconClass: 'el-icon-loading',
            message: '数据获取中'
          });
          this.$get('agentapi/admin/getTerminalSbqk', {
            id: row.id
          }).then(function (res) {
            _this4.isSyqkDialog = true;
            _this4.isSyqkObj = res;
            _this4.load.close();
          });
          break;
        case 14:
          this.$get('agentapi/get_promoter_agent', {
            current_agent_id: row.id
          }).then(function (res) {
            _this4.addPromoterAgentObj = {
              current_agent_id: row.id,
              id: res.id || 0,
              name: res.name || '',
              phone: res.phone || '',
              agent_percent: res.agent_percent || 0,
              is_delete: res.is_delete || 0,
              remark: res.remark || ''
            };
            _this4.addPromoterAgentDialog = true;
          });
          break;
        case 15:
          {
            var aid = row.aid || row.id;
            this.merchantElectricityAuthObj = {
              aid: aid,
              name: row.name || '',
              has_access: 0
            };
            this.merchantElectricityAuthLoading = true;
            this.merchantElectricityAuthSaving = false;
            this.merchantElectricityAuthSkipSave = true;
            this.merchantElectricityAuthDialog = true;
            this.$get('agentapi/merchant_electricity_auth/get_agent_auth', {
              aid: aid
            }).then(function (res) {
              _this4.merchantElectricityAuthObj.has_access = res.has_access !== undefined ? parseInt(res.has_access, 10) : 0;
              if (res.name) {
                _this4.merchantElectricityAuthObj.name = res.name;
              }
            }).catch(function () {
              /* 接口失败时仍展示弹窗，默认未授权 */
            }).finally(function () {
              _this4.merchantElectricityAuthLoading = false;
              _this4.$nextTick(function () {
                _this4.merchantElectricityAuthSkipSave = false;
              });
            });
            break;
          }
      }
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    /**
     * 分配设备
     */
    setEquip: function setEquip(row) {
      var _this5 = this;
      this.loadObj = this.$loading({
        lock: true,
        text: '正在分配',
        spinner: 'el-icon-loading'
      });
      // 【操作埋点】2026-05-25 pc_agent_distribute_1 分配设备
      this.$post('agentapi/save_distribute_agent_devices', {
        son_id: row.id,
        goods_sn: this.zuo_sn.split(',')
      }, {
        operation_option: '分配设备',
        content: "\u4EE3\u7406\u5546ID\uFF1A".concat(row.id, "\uFF0C\u8BBE\u5907SN\uFF1A").concat(this.zuo_sn),
        operation_id: 'pc_agent_distribute_1'
      }).then(function (res) {
        res.bind_fail = res.bind_fail || [];
        if (res.bind_fail.length == 0) {
          _this5.loadObj.close();
          _this5.$message({
            message: '分配成功',
            type: 'success'
          });
          history.back();
        } else {
          _this5.loadObj.close();
          var str = res.bind_fail.toString();
          _this5.$alert('【' + str + '】等设备未分配成功，', '分配失败', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              history.back();
            }
          });
        }
      }).catch(function () {
        _this5.loadObj.close();
      });
    },
    /**
     * 设置提现费率
     */
    setWithdraw: function setWithdraw() {
      var _this6 = this;
      // 【操作埋点】2026-05-25 pc_agent_withdraw_1 设置提现费率
      this.$post('agentapi/save_agent_withdraw_percent', {
        son_id: this.withdrawObj.id,
        withdraw_percent: this.withdrawObj.withdraw_percent,
        withdraw_fee: this.withdrawObj.withdraw_fee
      }, {
        operation_option: '设置提现费率',
        content: "\u4EE3\u7406(ID:".concat(this.withdrawObj.id, ") \u63D0\u73B0\u6BD4\u4F8B ").concat(this.withdrawObj.withdraw_percent, "%\uFF0C\u624B\u7EED\u8D39 ").concat(this.withdrawObj.withdraw_fee, " \u5143"),
        operation_id: 'pc_agent_withdraw_1'
      }).then(function (res) {
        _this6.$message({
          message: '设置成功',
          type: 'success'
        });
        _this6.withdrawDialog = false;
      });
    },
    show_confirm: function show_confirm() {
      var _this7 = this;
      this.$confirm('确定清除绑定的用户吗？', '解绑用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 【操作埋点】2026-05-25 pc_agent_account_1 解绑用户
        _this7.$post('agentapi/ucenter/save_bind_info', {
          agent_aid: _this7.isFrozenObj.admin_id
        }, {
          operation_option: '解绑用户',
          content: "\u4EE3\u7406\u5546ID\uFF1A".concat(_this7.isFrozenObj.admin_id),
          operation_id: 'pc_agent_account_1'
        }).then(function (res) {
          _this7.$message({
            message: '清除解绑成功',
            type: 'success'
          });
          _this7.isFrozenDialog = false;
        });
      }).catch(function () {
        _this7.is_clear_wx_user = 0;
      });
    },
    setIsFrozen: function setIsFrozen() {
      var _this8 = this;
      // 【操作埋点】2026-05-25 pc_agent_account_1 账号设置（含冻结/提现/计费等）
      this.$post('agentapi/admin/setFrozen', {
        admin_id: this.isFrozenObj.admin_id,
        is_frozen: this.isFrozenObj.is_frozen,
        is_allow_withdrawal: this.isFrozenObj.is_allow_withdrawal,
        is_use_cheap: this.isFrozenObj.is_use_cheap,
        card_charges_type: this.isFrozenObj.card_charges_type,
        second_charge: this.isFrozenObj.second_charge,
        ten_charge: this.isFrozenObj.ten_charge,
        six_charge: this.isFrozenObj.six_charge,
        cdb_charge: this.isFrozenObj.cdb_charge
      }, {
        operation_option: '账号设置',
        content: (0, _reportContent.buildReportContent)(this.isFrozenObj, _reportContent.AGENT_FROZEN_LABELS, {
          prefix: "\u4EE3\u7406\u5546ID ".concat(this.isFrozenObj.admin_id),
          formatters: {
            is_frozen: _reportContent.formatYesNo,
            is_allow_withdrawal: _reportContent.formatYesNo,
            is_use_cheap: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_agent_account_1'
      }).then(function (res) {
        _this8.$message({
          message: '设置成功',
          type: 'success'
        });
        _this8.isFrozenDialog = false;
      });
    },
    /**
     * terminal角色 打开代理账号设置弹窗
     */
    openTerminalAccountSetting: function openTerminalAccountSetting(row) {
      var self = this;
      self.terminalAccountSettingVisible = true;
      self.terminalAccountLoading = true;
      self.terminalAccountObj = {
        aid: row.aid || row.id,
        is_disable_account: 0,
        is_disable_equipment: 0,
        is_frozen: 0
      };
      self.$get('agentapi/admin/getAdminOtherSetting', {
        aid: row.aid || row.id
      }).then(function (res) {
        self.terminalAccountLoading = false;
        if (res) {
          self.terminalAccountObj = {
            aid: row.aid || row.id,
            is_disable_account: res.is_disable_account || 0,
            is_disable_equipment: res.is_disable_equipment || 0,
            is_frozen: res.is_frozen !== undefined ? parseInt(res.is_frozen) : 0
          };
        }
      }).catch(function () {
        self.terminalAccountLoading = false;
      });
    },
    /**
     * terminal角色 保存代理账号设置
     */
    saveTerminalAccountSetting: function saveTerminalAccountSetting() {
      var self = this;
      self.terminalAccountSaving = true;
      self.$post('agentapi/admin/setAdminOtherSetting', {
        aid: self.terminalAccountObj.aid,
        is_disable_account: self.terminalAccountObj.is_disable_account,
        is_disable_equipment: self.terminalAccountObj.is_disable_equipment,
        is_frozen: self.terminalAccountObj.is_frozen
      }).then(function (res) {
        self.terminalAccountSaving = false;
        self.$message({
          message: '设置成功',
          type: 'success'
        });
        self.terminalAccountSettingVisible = false;
      }).catch(function (err) {
        self.terminalAccountSaving = false;
        self.$message.error(err && err.msg || '设置失败');
      });
    },
    setIsYezz: function setIsYezz() {
      var _this9 = this;
      // 【操作埋点】2026-05-25 pc_agent_yezz_1 认证设置
      this.$post('agentapi/admin/setYezz', {
        admin_id: this.isYezzObj.admin_id,
        is_yezz: this.isYezzObj.is_yezz,
        max_steal_order_right_ration: this.isYezzObj.max_steal_order_right_ration
      }, {
        operation_option: '认证设置',
        content: (0, _reportContent.buildReportContent)(this.isYezzObj, _reportContent.AGENT_YEZZ_LABELS, {
          prefix: "\u4EE3\u7406\u5546ID ".concat(this.isYezzObj.admin_id),
          formatters: {
            is_yezz: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_agent_yezz_1'
      }).then(function (res) {
        _this9.$message({
          message: '设置成功',
          type: 'success'
        });
        _this9.isYezzDialog = false;
      });
    },
    addPromoterAgent: function addPromoterAgent() {
      var _this0 = this;
      if (!this.addPromoterAgentObj.name) {
        this.$message({
          message: '请输入推荐官姓名',
          type: 'error'
        });
        return;
      }
      if (!this.addPromoterAgentObj.phone) {
        this.$message({
          message: '请输入手机号码',
          type: 'error'
        });
        return;
      }
      this.$post('agentapi/admin/add_promoter_agent', {
        current_agent_id: this.addPromoterAgentObj.current_agent_id,
        name: this.addPromoterAgentObj.name,
        phone: this.addPromoterAgentObj.phone,
        agent_percent: this.addPromoterAgentObj.agent_percent || 0,
        is_delete: this.addPromoterAgentObj.is_delete || 0,
        remark: this.addPromoterAgentObj.remark || ''
      }).then(function (res) {
        _this0.$message({
          message: '添加成功',
          type: 'success'
        });
        _this0.addPromoterAgentDialog = false;
      }).catch(function (err) {
        _this0.$message({
          message: '添加失败',
          type: 'error'
        });
      });
    },
    onMerchantElectricityAuthChange: function onMerchantElectricityAuthChange(val) {
      var _this1 = this;
      if (this.merchantElectricityAuthSkipSave || this.merchantElectricityAuthLoading) {
        return;
      }
      var obj = this.merchantElectricityAuthObj;
      var prev = val ? 0 : 1;
      this.merchantElectricityAuthSaving = true;
      this.$post('agentapi/merchant_electricity_auth/save_agent_auth', {
        aid: obj.aid,
        has_access: val
      }).then(function () {
        _this1.$message({
          message: val ? '已开启商户电费' : '已关闭商户电费',
          type: 'success'
        });
      }).catch(function () {
        _this1.merchantElectricityAuthObj.has_access = prev;
      }).finally(function () {
        _this1.merchantElectricityAuthSaving = false;
      });
    },
    saveMerchantElectricityAuth: function saveMerchantElectricityAuth() {
      this.onMerchantElectricityAuthChange(this.merchantElectricityAuthObj.has_access);
    },
    setAgentBalance: function setAgentBalance() {
      var _this10 = this;
      // 【操作埋点】2026-05-25 pc_agent_deposit_1 余额/押金分成设置
      this.$post('agentapi/admin/setDeposit', {
        'agents_id': this.balanceSetObj.agent_id,
        'is_deposit_sharing': this.balanceSetObj.is_deposit_sharing,
        'store_deposit_sharing_ratio': this.balanceSetObj.store_deposit_sharing_ratio,
        'agent_sharing_ratio': this.balanceSetObj.agent_sharing_ratio
      }, {
        operation_option: '余额设置',
        content: (0, _reportContent.buildReportContent)(this.balanceSetObj, _reportContent.AGENT_DEPOSIT_LABELS, {
          prefix: "\u4EE3\u7406\u5546ID ".concat(this.balanceSetObj.agent_id),
          formatters: {
            is_deposit_sharing: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_agent_deposit_1'
      }).then(function (res) {
        _this10.$message({
          message: '设置成功',
          type: 'success'
        });
        _this10.banlanceSetDialog = false;
      });
    },
    /**
    * 设置提现手续费
    */
    setWithdrawFee: function setWithdrawFee() {
      var _this11 = this;
      // 【操作埋点】2026-05-25 pc_agent_withdraw_fee_1 提现手续费设置
      this.$post('agentapi/setAdminWithdrawConfig', {
        'admin_id': this.withdrawFeeObj.admin_id,
        'id': this.withdrawFeeObj.id,
        'config_mode': this.withdrawFeeObj.config_mode,
        'withdraw_rate': this.withdrawFeeObj.withdraw_rate,
        'withdraw_amount': this.withdrawFeeObj.withdraw_amount
      }, {
        operation_option: '提现手续费设置',
        content: (0, _reportContent.buildReportContent)(this.withdrawFeeObj, _reportContent.AGENT_WITHDRAW_FEE_LABELS, {
          prefix: "\u4EE3\u7406\u5546ID ".concat(this.withdrawFeeObj.admin_id)
        }),
        operation_id: 'pc_agent_withdraw_fee_1'
      }).then(function (res) {
        _this11.$message({
          message: '设置成功',
          type: 'success'
        });
        _this11.withdrawFeeDialog = false;
      });
    },
    /**
     * 获取地图图标
     */
    getMapIcon: function getMapIcon(row) {
      var _this12 = this;
      var brand_icon = {};
      this.freeObj = row;
      this.$get('agentapi/system/brand_icon', {
        platform_id: this.freeObj.aid
      }).then(function (res) {
        for (var i in _this12.deviceNameObj) {
          brand_icon["device_url_".concat(_this12.deviceNameObj[i])] = res["device_url_".concat(_this12.deviceNameObj[i])] || '';
        }
        _this12.brand_icon = brand_icon;
        _this12.iconDialog = true;
      });
    },
    /**
     * 修改地图图标
     */
    editDtIcon: function editDtIcon() {
      var _this13 = this;
      var params = this.brand_icon;
      params.platform_id = this.freeObj.aid;

      // 【操作埋点】2026-05-25 pc_agent_icon_1 修改地图图标
      this.$post('agentapi/system/brand_icon', params, {
        operation_option: '修改地图图标',
        content: "\u5E73\u53F0ID\uFF1A".concat(this.freeObj.aid),
        operation_id: 'pc_agent_icon_1'
      }).then(function (res) {
        _this13.iconDialog = false;
        _this13.$message({
          message: '设置成功',
          type: 'success'
        });
      });
    },
    /**
     * 登录代理后台
     * @param {Object} row
     */
    toLogin: function toLogin(row) {
      var _this14 = this;
      this.loadObj = this.$loading({
        lock: true,
        text: '正在登录',
        spinner: 'el-icon-loading'
      });
      // 【操作埋点】2026-05-25 pc_agent_login_1 登录代理后台
      this.$post('agentapi/pretend_son_login', {
        son_id: row.id
      }, {
        operation_option: '登录代理后台',
        content: "\u4EE3\u7406\u5546ID\uFF1A".concat(row.id),
        operation_id: 'pc_agent_login_1'
      }).then(function (res) {
        if (res.hasOwnProperty('permission')) {
          (0, _auth.setPermission)((0, _auth.getPermission)('server_permission_menus'), 'server_permission1');
          (0, _auth.setPermission)((0, _auth.getPermission)('server_permission_roles'), 'server_permission_roles1');
          (0, _auth.removeToken)('server_permission_menus');
          (0, _auth.removeToken)('server_permission_roles');
          (0, _auth.setPermission)(res.permission.menus, 'server_permission_menus');
          (0, _auth.setPermission)(res.permission.roles, 'server_permission_roles');
        }
        (0, _auth.setToken)((0, _auth.getToken)(), 'token1');
        (0, _auth.setToken)(res.token);
        (0, _auth.setToken)(res.belong_partner_aid, 'agent_id');
        (0, _auth.setToken)(row.id, 'user_id');
        setTimeout(function () {
          location.href = '/home';
          _this14.loadObj.close();
        }, 500);
      });
    },
    breakEvenApiPayload: function breakEvenApiPayload() {
      return {
        aid: this.currentShopInfo.id,
        device_type: this.selectedDeviceType
      };
    },
    agentBreakEvenDeviceShape: function agentBreakEvenDeviceShape(row) {
      var base = {
        id: row.id,
        store_name: "".concat(row.name || '', "(").concat(row.agent_name || '').concat(row.aid != null ? row.aid : '', ")"),
        cdbcount: 0,
        cdxcount: 0,
        cdz10count: 0,
        cdz2count: 0,
        cdz2lycount: 0,
        cdz2hpcount: 0,
        zmcdbcount: 0,
        lykgczcount: 0
      };
      var di = row.device_info || {};
      var dk = this.deviceKeyObj || {};
      Object.keys(di).forEach(function (dt) {
        var cnt = parseInt(di[dt], 10) || 0;
        if (cnt <= 0) return;
        var label = String(dk[dt] || '');
        if (label.includes('充电线')) base.cdxcount += cnt;else if (label.includes('桌面')) base.zmcdbcount += cnt;else if (label.includes('蓝牙开关')) base.lykgczcount += cnt;else if (label.includes('10路') || label.includes('16路')) base.cdz10count += cnt;else if (label.includes('2路') && label.includes('蓝牙')) base.cdz2lycount += cnt;else if (label.includes('2路') && label.includes('大功率')) base.cdz2hpcount += cnt;else if (label.includes('2路')) base.cdz2count += cnt;else if (label.includes('充电宝')) base.cdbcount += cnt;else if (label.includes('桩')) base.cdz10count += cnt;else if (dt === '1') base.cdbcount += cnt;else if (dt === '3') base.cdxcount += cnt;else if (dt === '5') base.cdz10count += cnt;else if (dt === '9') base.cdxcount += cnt;else base.cdbcount += cnt;
      });
      return base;
    },
    breakEvenCalculationFun: function breakEvenCalculationFun(row) {
      this.breakEvenDialog = true;
      this.selectedDeviceType = '0';
      this.currentShopInfo = this.agentBreakEvenDeviceShape(row);
      this.getCalculateTotalCost();
    },
    getCalculateTotalCost: function getCalculateTotalCost() {
      var _this15 = this;
      this.calculateCostLoading = true;
      this.$get('agentapi/store/getStoreBreakEvenCost', this.breakEvenApiPayload()).then(function (res) {
        if (!res) {
          _this15.costForm.remark = '';
          _this15.costForm.totalCost = 0;
          _this15.costForm.deviceCost = 0;
          _this15.costForm.installationCost = 0;
          _this15.costForm.laborCost = 0;
          _this15.costForm.otherCost = 0;
          _this15.investmentRatio = {
            manage: '',
            partner: '',
            proxy: '',
            salesperson: '',
            promoter: '',
            merchants: ''
          };
        } else {
          _this15.costForm.remark = res.remark;
          _this15.costForm.deviceCost = res.device_cost;
          _this15.costForm.installationCost = res.install_cost;
          _this15.costForm.laborCost = res.labor_cost;
          _this15.costForm.otherCost = res.other_cost;
          var totalCost = parseFloat(res.device_cost || 0) + parseFloat(res.install_cost || 0) + parseFloat(res.labor_cost || 0) + parseFloat(res.other_cost || 0);
          _this15.costForm.totalCost = totalCost.toFixed(2);
          if (res.investment_ratio && (0, _typeof2.default)(res.investment_ratio) === 'object') {
            _this15.investmentRatio = res.investment_ratio;
          } else if (res.investment_ratio && typeof res.investment_ratio === 'string') {
            try {
              _this15.investmentRatio = JSON.parse(res.investment_ratio);
            } catch (e) {
              _this15.investmentRatio = {
                manage: '',
                partner: '',
                proxy: '',
                salesperson: '',
                promoter: '',
                merchants: ''
              };
            }
          } else {
            _this15.investmentRatio = {
              manage: '',
              partner: '',
              proxy: '',
              salesperson: '',
              promoter: '',
              merchants: ''
            };
          }
        }
      }).catch(function (err) {
        _this15.$message({
          message: '获取设备成本失败: ' + err.msg,
          type: 'error'
        });
      }).finally(function () {
        _this15.calculateCostLoading = false;
        _this15.getBreakEvenCycleData();
      });
    },
    calculateTotalCost: function calculateTotalCost() {
      var deviceCost = parseFloat(this.costForm.deviceCost) || 0;
      var installationCost = parseFloat(this.costForm.installationCost) || 0;
      var laborCost = parseFloat(this.costForm.laborCost) || 0;
      var otherCost = parseFloat(this.costForm.otherCost) || 0;
      var totalCost = deviceCost + installationCost + laborCost + otherCost;
      this.costForm.totalCost = totalCost.toFixed(2);
    },
    saveCalculateTotalCost: function saveCalculateTotalCost() {
      var _this16 = this;
      this.$post('agentapi/store/saveStoreBreakEvenCost', Object.assign({}, this.breakEvenApiPayload(), {
        device_cost: this.costForm.deviceCost,
        install_cost: this.costForm.installationCost,
        labor_cost: this.costForm.laborCost,
        other_cost: this.costForm.otherCost,
        remark: this.costForm.remark,
        investment_ratio: this.investmentRatio
      })).then(function (res) {
        var deviceCost = parseFloat(_this16.costForm.deviceCost) || 0;
        var installationCost = parseFloat(_this16.costForm.installationCost) || 0;
        var laborCost = parseFloat(_this16.costForm.laborCost) || 0;
        var otherCost = parseFloat(_this16.costForm.otherCost) || 0;
        var totalCost = deviceCost + installationCost + laborCost + otherCost;
        _this16.costForm.totalCost = totalCost.toFixed(2);
        _this16.$message({
          message: '保存成功',
          type: 'success'
        });
        _this16.getBreakEvenCycleData();
      }).catch(function (err) {
        _this16.$message({
          message: '保存失败: ' + err.message,
          type: 'error'
        });
      });
    },
    validateNumber: function validateNumber(eventOrValue, fieldName) {
      if (!fieldName) return;
      var value;
      if (eventOrValue && (0, _typeof2.default)(eventOrValue) === 'object' && eventOrValue.target) {
        value = eventOrValue.target.value;
      } else {
        value = eventOrValue;
      }
      if (value === undefined || value === null) value = '';
      var val = String(value).replace(/[^\d.]/g, '');
      var parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts.length === 2 && parts[1].length > 2) {
        val = parts[0] + '.' + parts[1].substring(0, 2);
      }
      if (this.costForm && this.costForm[fieldName] !== undefined) {
        this.costForm[fieldName] = val;
      }
    },
    validateInvestmentRatio: function validateInvestmentRatio(eventOrValue, fieldName) {
      if (!fieldName) return;
      var value;
      if (eventOrValue && (0, _typeof2.default)(eventOrValue) === 'object' && eventOrValue.target) {
        value = eventOrValue.target.value;
      } else {
        value = eventOrValue;
      }
      if (value === undefined || value === null) value = '';
      var val = String(value).replace(/[^\d.]/g, '');
      var parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts.length === 2 && parts[1].length > 2) {
        val = parts[0] + '.' + parts[1].substring(0, 2);
      }
      var numValue = parseFloat(val);
      if (!isNaN(numValue)) {
        if (numValue > 100) {
          val = '100';
          this.$message({
            message: '投资比例不能超过100%',
            type: 'warning'
          });
        } else if (numValue < 0) {
          val = '0';
        }
      }
      if (this.investmentRatio && this.investmentRatio[fieldName] !== undefined) {
        this.investmentRatio[fieldName] = val;
      }
      this.validateInvestmentRatioTotal();
    },
    validateInvestmentRatioTotal: function validateInvestmentRatioTotal() {
      var _this17 = this;
      var ratioFields = ['manage', 'partner', 'proxy', 'salesperson', 'promoter', 'merchants'];
      var total = 0;
      ratioFields.forEach(function (field) {
        var value = parseFloat(_this17.investmentRatio[field]) || 0;
        total += value;
      });
      if (total > 100) {
        this.$message({
          message: "\u6295\u8D44\u6BD4\u4F8B\u603B\u548C\u4E0D\u80FD\u8D85\u8FC7100%\uFF0C\u5F53\u524D\u603B\u548C\u4E3A".concat(total.toFixed(2), "%"),
          type: 'warning'
        });
      }
    },
    calculateDeviceTotalCostByType: function calculateDeviceTotalCostByType(costField) {
      var deviceCount = 0;
      var deviceCost = 0;
      switch (costField) {
        case 'cdbCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceCost = parseFloat(this.costForm.cdbCost) || 0;
          break;
        case 'cdxCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceCost = parseFloat(this.costForm.cdxCost) || 0;
          break;
        case 'cdz10Cost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceCost = parseFloat(this.costForm.cdz10Cost) || 0;
          break;
        case 'cdz2Cost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceCost = parseFloat(this.costForm.cdz2Cost) || 0;
          break;
        case 'cdz2lyCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceCost = parseFloat(this.costForm.cdz2lyCost) || 0;
          break;
        case 'cdz2hpCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceCost = parseFloat(this.costForm.cdz2hpCost) || 0;
          break;
        case 'zmcdbCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceCost = parseFloat(this.costForm.zmcdbCost) || 0;
          break;
        case 'lykgczCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceCost = parseFloat(this.costForm.lykgczCost) || 0;
          break;
        default:
          return;
      }
      var currentDeviceTotalCost = deviceCount * deviceCost;
      var existingDeviceCost = parseFloat(this.costForm.deviceCost) || 0;
      this.costForm.deviceCost = (currentDeviceTotalCost + existingDeviceCost).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u8BBE\u5907\u6210\u672C\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentDeviceTotalCost.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    calcDeviceInstallationTotalCostByType: function calcDeviceInstallationTotalCostByType(costField) {
      var deviceCount = 0;
      var deviceInstallCost = 0;
      switch (costField) {
        case 'cdbInstallCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdbInstallCost) || 0;
          break;
        case 'cdxInstallCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdxInstallCost) || 0;
          break;
        case 'cdz10InstallCost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz10InstallCost) || 0;
          break;
        case 'cdz2InstallCost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz2InstallCost) || 0;
          break;
        case 'cdz2lyInstallCost':
        case 'cdz2lybInstallCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz2lybInstallCost || this.costForm.cdz2lyInstallCost) || 0;
          break;
        case 'cdz2hpInstallCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz2hpInstallCost) || 0;
          break;
        case 'zmcdbInstallCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceInstallCost = parseFloat(this.costForm.zmcdbInstallCost) || 0;
          break;
        case 'lykgczInstallCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceInstallCost = parseFloat(this.costForm.lykgczInstallCost) || 0;
          break;
        default:
          return;
      }
      var currentTotal = deviceCount * deviceInstallCost;
      var existing = parseFloat(this.costForm.installationCost) || 0;
      this.costForm.installationCost = (currentTotal + existing).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u5B89\u88C5\u8D39\u7528\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentTotal.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    calcDeviceLaborTotalCostByType: function calcDeviceLaborTotalCostByType(costField) {
      var deviceCount = 0;
      var deviceLaborCost = 0;
      switch (costField) {
        case 'cdbLaborCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdbLaborCost) || 0;
          break;
        case 'cdxLaborCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdxLaborCost) || 0;
          break;
        case 'cdz10LaborCost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz10LaborCost) || 0;
          break;
        case 'cdz2LaborCost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz2LaborCost) || 0;
          break;
        case 'cdz2lyLaborCost':
        case 'cdz2lybLaborCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz2lybLaborCost || this.costForm.cdz2lyLaborCost) || 0;
          break;
        case 'cdz2hpLaborCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz2hpLaborCost) || 0;
          break;
        case 'zmcdbLaborCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceLaborCost = parseFloat(this.costForm.zmcdbLaborCost) || 0;
          break;
        case 'lykgczLaborCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceLaborCost = parseFloat(this.costForm.lykgczLaborCost) || 0;
          break;
        default:
          return;
      }
      var currentTotal = deviceCount * deviceLaborCost;
      var existing = parseFloat(this.costForm.laborCost) || 0;
      this.costForm.laborCost = (currentTotal + existing).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u4EBA\u5DE5\u8D39\u7528\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentTotal.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    calcDeviceOtherTotalCostByType: function calcDeviceOtherTotalCostByType(costField) {
      var deviceCount = 0;
      var deviceOtherCost = 0;
      switch (costField) {
        case 'cdbOtherCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdbOtherCost) || 0;
          break;
        case 'cdxOtherCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdxOtherCost) || 0;
          break;
        case 'cdz10OtherCost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz10OtherCost) || 0;
          break;
        case 'cdz2OtherCost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz2OtherCost) || 0;
          break;
        case 'cdz2lyOtherCost':
        case 'cdz2lybOtherCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz2lybOtherCost || this.costForm.cdz2lyOtherCost) || 0;
          break;
        case 'cdz2hpOtherCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz2hpOtherCost) || 0;
          break;
        case 'zmcdbOtherCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceOtherCost = parseFloat(this.costForm.zmcdbOtherCost) || 0;
          break;
        case 'lykgczOtherCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceOtherCost = parseFloat(this.costForm.lykgczOtherCost) || 0;
          break;
        default:
          return;
      }
      var currentTotal = deviceCount * deviceOtherCost;
      var existing = parseFloat(this.costForm.otherCost) || 0;
      this.costForm.otherCost = (currentTotal + existing).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u5176\u4ED6\u8D39\u7528\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentTotal.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    getBreakEvenCycleData: function getBreakEvenCycleData() {
      var _this18 = this;
      this.calculateCostLoading = true;
      this.breakEvenDays = 0;
      this.breakEvenPercentage = 0;
      this.averageDailyIncome = 0;
      this.recoveredCost = 0;
      this.remainingCost = 0;
      this.daysSinceOperation = 0;
      this.averageChangeMoneyMonth = 0;
      this.$get('agentapi/store/getStoreBreakEvenCycleData', this.breakEvenApiPayload()).then(function (res) {
        _this18.breakEvenDays = res.break_even_cycle;
        _this18.breakEvenPercentage = res.break_even_percentage;
        _this18.averageDailyIncome = res.average_change_money;
        _this18.recoveredCost = res.total_change_money;
        _this18.remainingCost = res.remain_cost;
        _this18.daysSinceOperation = res.days_since_operation;
        _this18.averageChangeMoneyMonth = res.average_change_money_month;
        if (res.change_money_ratio) {
          try {
            _this18.recoveryRatio = typeof res.change_money_ratio === 'string' ? JSON.parse(res.change_money_ratio) : res.change_money_ratio;
          } catch (e) {
            _this18.recoveryRatio = {
              manage: '',
              partner: '',
              proxy: '',
              salesperson: '',
              promoter: '',
              merchants: ''
            };
          }
        } else {
          _this18.recoveryRatio = {
            manage: '',
            partner: '',
            proxy: '',
            salesperson: '',
            promoter: '',
            merchants: ''
          };
          _this18.$message({
            message: '暂无订单数据。',
            type: 'warning'
          });
        }
      }).catch(function (err) {
        _this18.$message({
          message: '获取回本周期数据集和失败: ' + err.msg,
          type: 'warning'
        });
      }).finally(function () {
        _this18.calculateCostLoading = false;
      });
    },
    getBreakEvenCycleDataToList: function () {
      var _getBreakEvenCycleDataToList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this19 = this;
        var listData, requests;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              listData = this.list.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  break_even_profit: '读取中',
                  total_change_money: '读取中',
                  days_since_operation: '读取中'
                });
              });
              this.list = listData;
              requests = listData.map(function (item) {
                return _this19.$get('agentapi/store/getStoreBreakEvenCycleData', {
                  aid: item.id,
                  device_type: 0
                }).then(function (res) {
                  var index = _this19.list.findIndex(function (i) {
                    return i.id === item.id;
                  });
                  if (index !== -1) {
                    var recoveryData = {
                      manage: '',
                      partner: '',
                      proxy: '',
                      salesperson: '',
                      promoter: '',
                      merchants: ''
                    };
                    if (res.change_money_ratio && (0, _typeof2.default)(res.change_money_ratio) === 'object') {
                      var totalChangeMoney = parseFloat(res.total_change_money) || 0;
                      if (totalChangeMoney > 0) {
                        recoveryData = {
                          manage: res.change_money_ratio.manage ? (parseFloat(res.change_money_ratio.manage) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          partner: res.change_money_ratio.partner ? (parseFloat(res.change_money_ratio.partner) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          proxy: res.change_money_ratio.proxy ? (parseFloat(res.change_money_ratio.proxy) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          salesperson: res.change_money_ratio.salesperson ? (parseFloat(res.change_money_ratio.salesperson) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          promoter: res.change_money_ratio.promoter ? (parseFloat(res.change_money_ratio.promoter) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          merchants: res.change_money_ratio.merchants ? (parseFloat(res.change_money_ratio.merchants) / totalChangeMoney * 100).toFixed(2) : '0.00'
                        };
                      }
                    }
                    _this19.$set(_this19.list, index, _objectSpread(_objectSpread({}, _this19.list[index]), {}, {
                      break_even_profit: parseFloat((res.total_change_money - res.total_cost).toFixed(2)),
                      total_change_money: res.total_change_money,
                      days_since_operation: res.days_since_operation,
                      recovery_ratio: recoveryData
                    }));
                  }
                }).catch(function (err) {
                  var index = _this19.list.findIndex(function (i) {
                    return i.id === item.id;
                  });
                  if (index !== -1) {
                    _this19.$set(_this19.list, index, _objectSpread(_objectSpread({}, _this19.list[index]), {}, {
                      break_even_profit: '数据获取异常',
                      total_change_money: '数据获取异常',
                      days_since_operation: '数据获取异常'
                    }));
                  }
                });
              });
              _context.next = 1;
              return Promise.all(requests);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getBreakEvenCycleDataToList() {
        return _getBreakEvenCycleDataToList.apply(this, arguments);
      }
      return getBreakEvenCycleDataToList;
    }(),
    /**
     * 复制贴牌登录地址
     * @param {Object} row
     */
    copyloginUrl: function copyloginUrl(row) {
      (0, _index.copyText)("".concat(location.origin, "/login/").concat(row.id));
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    }
  }
};